import React from 'react';

const advantages: Array<{ img: any; alt: string; h4: string; p: string }> = [
	{
		img: require('@app/images/link-icons/vet.svg'),
		alt: 'icon',
		h4: 'End-of-Life Resources',
		p: 'Access information on veterinary hospice care, euthanasia best practices, and sedation protocols.',
	},
	{
		img: require('@app/images/Scale_Icon.png'),
		alt: 'icon',
		h4: 'Veterinary Articles',
		p: 'Read articles on medical and technical topics, as well as business advice for veterinarians and clinics.',
	},
	{
		img: require('@app/images/aftercare.svg'),
		alt: 'icon',
		h4: 'Tips and Tools',
		p: 'Explore helpful links for veterinary professionals as well as resources for your patients and clients.',
	},
];

const Advantages: React.FC = () => {
	return (
		<section className="advantages">
			<div className="advantages-wrap">
				<h3>Access Our Veterinary Resource Center</h3>
				<p>We provide a wealth of information and many FREE tools to veterinarians and clinics. Sign up or log in below.</p>
				<div className="advantages-wrap-group">
					{advantages.map((advantage, i) => (
						<div key={i} className="advantages-wrap-group__advantage">
							<div className="icon">
								<img src={advantage.img} alt={advantage.alt} />
							</div>
							<h4>{advantage.h4}</h4>
							<p>{advantage.p}</p>
						</div>
					))}
				</div>
			</div>
		</section>
	);
};

export default Advantages;
